export default function () {
  const { $ } = window as any
  // close alert after 15 sec
  const closeAlert = () => $('.alert:not(.alert-permanent)').alert('close')
  window.setTimeout(closeAlert, 15000)
}
